import React, { createContext, useContext, useMemo } from 'react';

export type EnterpriseStorefrontContextValue = {
  enterpriseId: string;
  websiteId?: string;
  dispensaryId: string;
};

const EnterpriseStorefrontContext = createContext<EnterpriseStorefrontContextValue | null>(null);

type EnterpriseStorefrontProviderProps = EnterpriseStorefrontContextValue & {
  children: React.ReactNode;
};

/**
 * Supplies the enterprise website and its always-required selected dispensary to
 * clean custom-domain pages that do not carry a store identifier in the URL.
 */
export function EnterpriseStorefrontProvider({
  enterpriseId,
  websiteId,
  dispensaryId,
  children,
}: EnterpriseStorefrontProviderProps): JSX.Element {
  const value = useMemo(() => ({ enterpriseId, websiteId, dispensaryId }), [enterpriseId, websiteId, dispensaryId]);
  return <EnterpriseStorefrontContext.Provider value={value}>{children}</EnterpriseStorefrontContext.Provider>;
}

export function useEnterpriseStorefrontContext(): EnterpriseStorefrontContextValue | null {
  return useContext(EnterpriseStorefrontContext);
}
